import { createContext } from "react";



export const LoginContext = createContext({});
export const BetContext = createContext({});
export const ToastContext = createContext({});
export const RefreshSocketContext = createContext({});